import logoutJupyterHandler from './logoutJupyterHandler';

export default logoutJupyterHandler;
